/**
 * Get all meter nodes
 * @param {object} member - This can be a meter/property/user
 * @returns {Array<object>} - array of meter nodes
 */
const getMemberNodes = (member) => member?.edges?.map((edge) => edge.node) || [];

export default getMemberNodes;
